require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-ساوند-كلاود.json") })
        }
      }, "path---tags-ساوند-كلاود");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-ساوند-كلاود!./.cache/json/tags-ساوند-كلاود.json
// module id = 610
// module chunks = 231608221292675